module.exports = __webpack_public_path__ + "media/site_templates/www.cheaptaxaccountants.com.au/images/our_services_3-5dfefbefef965f9bbd5c881da748e733.jpg";